<template>
    <div>
        <breadcrumb :routerList="[{to:'/chanp/reform',title:'改制单列表'},{title:'查看改制单'}]"/>
        <div class="h-content">
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <el-form :model="f" label-position="right" ref="f" :inline="true" :rules="rules"
                                 class="demo-ruleForm h-formbLine h-formbLine1">
                            <div class="h-rowCon">

                                <div class="h-pieceIn2">
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>改制需求</h1>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine Yangbiao">
                                            <el-form-item label="改制需求号" class="h-elformWrap-2" prop="reformId">
                                                <el-input v-model="f.reformId" placeholder="请输入" readonly>
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item label="经销商编码" class="h-elformWrap-2" prop="agentCode">
                                                <el-input v-model="f.agentCode" placeholder="请输入" readonly>
                                                </el-input>
                                            </el-form-item>

                                            <el-form-item label="经销商名称" class="h-elformWrap-2" prop="agentName">
                                                <el-input placeholder="输入经销商编码自动带出" v-model="f.agentName" readonly></el-input>
                                            </el-form-item>

                                            <el-form-item label="区域" class="h-elformWrap-2" prop="areaName">
                                                <el-input v-model="f.areaName" placeholder="请输入" readonly>
                                                </el-input>
                                            </el-form-item>

                                            <el-form-item label="链群" class="h-elformWrap-2" prop="lianqunName">
                                                <el-input v-model="f.lianqunName" placeholder="请输入" readonly>
                                                </el-input>
                                            </el-form-item>

                                            <el-form-item label="产品编码" class="h-elformWrap-2" prop="materialCode">
                                                <el-input v-model="f.materialCode" placeholder="请输入" readonly>
                                                </el-input>
                                            </el-form-item>

                                            <el-form-item label="产品型号" class="h-elformWrap-2" prop="materialName">
                                                <el-input placeholder="输入产品编码自动带出" v-model="f.materialName" readonly></el-input>
                                            </el-form-item>

                                            <el-form-item label="数量" class="h-elformWrap-2" prop="number">
                                                <el-input placeholder="请输入"v-model.number="f.number" readonly></el-input>
                                            </el-form-item>

                                            <el-form-item label="产品大类" class="h-elformWrap-2" prop="oneLName">
                                                <el-input placeholder="输入产品编码自动带出" v-model="f.oneLName" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="单台加价" class="h-elformWrap-2" prop="reformPrice">
                                                <el-input  placeholder="选择改制信息自动计算" v-model="f.reformPrice" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="型号经理工号" class="h-elformWrap-2" prop="typeUserCode">
                                                <el-input placeholder="请输入工号" v-model="f.typeUserCode" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="型号经理名称" class="h-elformWrap-2" prop="typeUserName">
                                                <el-input placeholder="输入工号自动带出" v-model="f.typeUserName"  readonly ></el-input>
                                            </el-form-item>
                                            <el-form-item
                                                    label="生产日期"
                                                    class="h-elformWrap-2"
                                                    prop="produceTime">
                                                <div class="block">
                                                    <el-date-picker
                                                            v-model="f.produceTime"
                                                            type="date"
                                                            readonly
                                                            :clearable="false"
                                                            value-format="yyyy-MM-dd"
                                                            placeholder="--请先选择生产日期--"
                                                    >
                                                    </el-date-picker>
                                                </div>
                                            </el-form-item>
                                            <el-form-item label="备注" class="h-elformWrap-2" prop="remark">
                                                <el-input  v-model="f.remark" ></el-input>
                                            </el-form-item>
                                            <el-form-item label="附件" class="h-elformWrap-2">
                                                <brupload
                                                        :refid="f.id"
                                                        reftype="附件"
                                                        :uploadflag="false"
                                                        :delflag="false"
                                                        :showtime="false"
                                                >
                                                </brupload>
                                            </el-form-item>
                                            <div>

                                                <div v-for="(listIt, index) in f.specificList" :key="index" class="h-formBox">

                                                    <el-form-item  class="h-elformWrap-3" >
                                                        <template slot="label">
                                                            改制目录{{index+1}}
                                                        </template>
                                                        <el-input  v-model="f.specificList[index].specificDivision" ></el-input>
                                                    </el-form-item>
                                                    <el-form-item  class="h-elformWrap-3" >
                                                        <template slot="label">
                                                            改制要求{{index+1}}
                                                        </template>
                                                        <el-input  v-model="f.specificList[index].specificReform" ></el-input>
                                                    </el-form-item>
                                                    <el-form-item  class="h-elformWrap-3" >
                                                        <template slot="label">
                                                            改制数量{{index+1}}
                                                        </template>
                                                        <el-input placeholder="请输入改制数量" v-model="f.specificList[index].reformNum" @change="calReformPrice"></el-input>
                                                    </el-form-item>
                                                    <el-form-item  class="h-elformWrap-3" >
                                                        <template slot="label">
                                                            单台加价{{index+1}}
                                                        </template>
                                                        <el-input placeholder="单台加价" v-model="f.specificList[index].reformPrice" readonly></el-input>
                                                    </el-form-item>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="N-chan">
                                    <div class="h-pieceTitle2">
                                        <h1>改制确认</h1>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine Yangbiao">
                                            <el-form-item label="产值(元)" class="h-elformWrap-2" prop="outputValue">
                                                <el-input v-model="f.outputValue" placeholder="请输入" readonly>
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item label="标准台" class="h-elformWrap-2" prop="standardTable">
                                                <el-input v-model="f.standardTable" placeholder="请输入" readonly>
                                                </el-input>
                                            </el-form-item>
                                        </div>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine Yangbiao">
                                            <div v-for="(listIt, index) in f.individualizeList" :key="index" class="h-formBox">
                                                <el-form-item  class="h-elformWrap-35" >
                                                    <template slot="label">
                                                        个性化定制标准描述{{index+1}}
                                                    </template>
                                                    <el-input placeholder="由型号经理填写" v-model="f.individualizeList[index]" readonly></el-input>
                                                </el-form-item>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine Yangbiao">
                                            <div v-for="(listIt, index) in f.logoRequestList" :key="index" class="h-formBox">
                                                <el-form-item  class="h-elformWrap-35" >
                                                    <template slot="label">
                                                        包装标识要求{{index+1}}
                                                    </template>
                                                    <el-input placeholder="由型号经理填写" v-model="f.logoRequestList[index]" readonly></el-input>
                                                </el-form-item>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine Yangbiao">
                                            <el-form-item label="改制类型" class="h-elformWrap-2" prop="reformType" >
                                                <el-select  v-model="f.reformType" disabled >
                                                    <el-option value="0" label="生产改制"></el-option>
                                                    <el-option value="1" label="库存改制"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="生产版本" class="h-elformWrap-2" prop="reformEdition" >
                                                <brselect disabled category="gaizhi_edition_nx" :v="f.reformEdition" v-model="f.reformEdition"/>
                                            </el-form-item>
                                            <el-form-item label="物料工位" class="h-elformWrap-5" prop="stationlist" >
                                                <el-checkbox-group v-model="f.stationlist" disabled>
                                                    <el-checkbox v-for="item in options" :label="item.code" :key="item.code" >{{item.name}}</el-checkbox>
                                                </el-checkbox-group>
                                            </el-form-item>
                                            <el-form-item label="检测要求" class="h-elformWrap-5" prop="checkRequest">
                                                <el-input type="textarea" placeholder="请输入检测要求" autosize v-model="f.checkRequest" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="涉及主关件变更的测试计划及测试报告" class="h-elformWrap-5">
                                                <brupload
                                                        :refid="f.id"
                                                        reftype="改制明细测试报告"
                                                        :uploadflag="false"
                                                        :delflag="false"
                                                        :showtime="false"
                                                >
                                                </brupload>
                                            </el-form-item>

                                        </div>
                                    </div>

                                </div>

                                <el-table
                                        ref="multipleTable"
                                        :data="f.reformMainDetailList"
                                        border
                                        style="width: 100%">
                                    <el-table-column label="个性化改制物料明细">
                                        <el-table-column
                                                prop="orderby"
                                                label="序号"
                                                width="50">
                                            <template slot-scope="scope">
                                                {{scope.row.orderby}}
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="materialName"
                                                label="物料描述"
                                                :show-overflow-tooltip="true"
                                                width="130">
                                            <template slot-scope="scope">
                                                <div>
                                                    {{scope.row.materialName}}
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="materialCode"
                                                label="物料专用号"
                                                width="130">
                                            <template slot-scope="scope">
                                                <div>
                                                    {{scope.row.materialCode}}
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="purchaseGroup"
                                                label="采购组"
                                                width="80">
                                            <template slot-scope="scope">
                                                {{scope.row.purchaseGroup}}
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="materialOrder"
                                                label="物料单耗"
                                                width="50">
                                            <template slot-scope="scope">
                                                <div>
                                                    {{scope.row.materialOrder}}
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="unit"
                                                label="单位"
                                                width="50">
                                            <template slot-scope="scope">
                                                <div>
                                                    {{scope.row.unit}}
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="numbermb"
                                                label="模板导入数量"
                                                width="50">
                                            <template slot-scope="scope">
                                                <div>
                                                    {{scope.row.numbermb}}
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="numberjs"
                                                label="系统计算数量"
                                                width="50">
                                            <template slot-scope="scope">
                                                <div>
                                                    {{scope.row.numberjs}}
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="number"
                                                label="最终使用数量"
                                                width="50">
                                            <template slot-scope="scope">
                                                <div>
                                                    {{scope.row.number}}
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="isSelf"
                                                label="自制/外购"
                                                width="90"
                                                :show-overflow-tooltip="true">
                                            <template slot-scope="scope">
                                                <div>
                                                    <div v-if="scope.row.isSelf == 0">外购</div>
                                                    <div v-if="scope.row.isSelf == 1">自制</div>
                                                    <div v-if="scope.row.isSelf == 2">外购-厂家改制</div>
                                                    <div v-if="scope.row.isSelf == 3">外购-到厂改制</div>
                                                </div>
                                            </template>
                                        </el-table-column>


                                        <el-table-column
                                                prop="remark"
                                                label="备注"
                                                :show-overflow-tooltip="true"
                                                width="200">
                                            <template slot-scope="scope">
                                                <div>
                                                    {{scope.row.remark}}
                                                </div>
                                            </template>
                                        </el-table-column>

                                        <el-table-column
                                                prop="supplierName"
                                                label="供应商名称"
                                                :show-overflow-tooltip="true"
                                                width="200">
                                            <template slot-scope="scope">
                                                <div>
                                                    {{scope.row.supplierName}}
                                                </div>
                                            </template>
                                        </el-table-column>

                                        <el-table-column
                                                label="图纸"
                                                :show-overflow-tooltip="true"
                                                fixed
                                                min-width="150">
                                            <template slot-scope="scope">
                                                <brupload
                                                        :refid="scope.row.id"
                                                        reftype="改制物料明细"
                                                        :showtime="false">
                                                </brupload>
                                            </template>
                                        </el-table-column>

                                        <el-table-column
                                                prop="changeDes"
                                                label="变更描述"
                                                :show-overflow-tooltip="true"
                                                width="200">
                                            <template slot-scope="scope">
                                                <div>
                                                    {{scope.row.changeDes}}
                                                </div>
                                            </template>
                                        </el-table-column>

                                    </el-table-column>
                                    <el-table-column label="替换物料明细">
                                        <el-table-column
                                                prop="materialNameTh"
                                                label="物料描述"
                                                :show-overflow-tooltip="true"
                                                width="130">
                                            <template slot-scope="scope">
                                                <div>
                                                    {{scope.row.materialNameTh}}
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="materialCodeTh"
                                                label="物料专用号"
                                                width="90">
                                            <template slot-scope="scope">
                                                <div>
                                                    {{scope.row.materialCodeTh}}
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="unitTh"
                                                label="单位"
                                                width="50">
                                            <template slot-scope="scope">
                                                <div>
                                                    {{scope.row.unitTh}}
                                                </div>
                                            </template>
                                        </el-table-column>
                                       <!-- <el-table-column
                                                prop="numbermbTh"
                                                label="模板导入数量"
                                                width="50">
                                            <template slot-scope="scope">
                                                <div>
                                                    {{scope.row.numbermbTh}}
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="numberjsTh"
                                                label="系统计算数量"
                                                width="50">
                                            <template slot-scope="scope">
                                                <div>
                                                    {{scope.row.numberjsTh}}
                                                </div>
                                            </template>
                                        </el-table-column>-->
                                        <el-table-column
                                                prop="numberTh"
                                                label="最终使用数量"
                                                width="50">
                                            <template slot-scope="scope">
                                                <div>
                                                    {{scope.row.numberTh}}
                                                </div>
                                            </template>
                                        </el-table-column>

                                        <el-table-column
                                                prop="remarkTh"
                                                label="备注"
                                                :show-overflow-tooltip="true"
                                                width="200">
                                            <template slot-scope="scope">
                                                <div>
                                                    {{scope.row.remarkTh}}
                                                </div>
                                            </template>
                                        </el-table-column>

                                        <el-table-column
                                                prop="supplierNameTh"
                                                label="供应商名称"
                                                :show-overflow-tooltip="true"
                                                width="200">
                                            <template slot-scope="scope">
                                                <div>
                                                    {{scope.row.supplierNameTh}}
                                                </div>
                                            </template>
                                        </el-table-column>

                                        <el-table-column
                                                label="图纸"
                                                :show-overflow-tooltip="true"
                                                fixed
                                                min-width="150">
                                            <template slot-scope="scope">
                                                <brupload
                                                        :refid="scope.row.id"
                                                        reftype="替换物料明细"
                                                        :showtime="false">
                                                </brupload>
                                            </template>
                                        </el-table-column>

                                    </el-table-column>
                                </el-table>
                            </div>

                        </el-form>

                    </div>
                </div>
            </div>


            <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="f.instid"/>

            <div class="h-txtCenter h-mrt60">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="backS">返回</el-button>
                <el-button class="el-button h-btn el-button--default" @click="viewpress">审批跟踪</el-button>

            </div>


        </div>
    </div>
</template>

<script>
    import reformService from "../../../api/reform/reformService.js";
    import uploaddownexcel from "../../../components/uploaddown/uploaddownexcel";
    import ss from "../../../api/SystemService";
    import _ from "loadsh";

    export default {
        components: {
            uploaddownexcel,

        },

        data() {
            return {
                showhistory:false,


                //全部物料工位
                options: [],

                //导入Excel
                uploaddownexcelflag: false,



                //带线表单
                f: {
                    agentCode:null, // 经销商编码
                    agentName:null, // 经销商名称
                    areaCode:null, // 区域编码
                    areaName:null, // 区域名称
                    lianqun:null, // 链群`
                    lianqunName:null, // 链群名称
                    materialCode:null, // 物料编码
                    materialName:null, // 物料名称
                    number:null, // 数量
                   /* specificIds:null, // 改制大id
                    specificDivisions:null,//改制大类
                    specificReqs:null, // 改制大描述*/
                    oneLId:null, // 产品大类编码
                    oneLName:null, // 产品大类名称
                    reformPrice:null, // 定制加价（单台）
                    instid:null,
                    reformId:null, // 定制编号
                    typeUserCode:null,//型号经理编码
                    typeUserName:null,//型号经理名称
                    reformType:'',//0生产改制1库存改制
                    reformEdition:'',//生产版本
                    materialStation:null,//物料工位
                    //物料明细
                    reformMainDetailList: [{materialName:'',materialCode:'',materialOrder:'',unit:'',number:'',isSelf:'',remark:'',
                        materialNameTh:'',materialCodeTh:'',materialOrderTh:'',numberTh:'',remarkTh:'',supplierNameTh:'',
                        supplierName:'',changeDes:''}],
                    //改制明细
                    specificList: [{
                        specificId: '',//改制id
                        specificDivision: '',//改制目录
                        specificReform: '',//改制要求
                        reformPrice: '',//单台加价
                        specificType:'',////1目录内改制 2目录外外改制
                        reformNum:0,
                    }],
                    //型号经理录入 （个性化定制标准描述）
                    individualizeList:[''],
                    //型号经理录入 (包装标识要求)
                    logoRequestList:[''],

                    remark:null,//备注
                    //选择的物料工位
                    stationlist:[],
                    // 产值(元)
                    outputValue:null,
                    // 标准台
                    standardTable:null,
                },


                rules: {
                    reformId:[{required: true, message: '需求号必填', trigger: 'change'}],
                    agentCode: [{required: true, message: '请选择经销商', trigger: 'change'}],
                    agentName: [{required: true, message: '请选择经销商', trigger: 'change'}],
                    areaName: [{required: true, message: '请选择区域', trigger: 'change'}],
                    lianqunName: [{required: true, message: '请选择链群', trigger: 'change'}],
                    materialCode: [{required: true, message: '请选择物料', trigger: 'change'}],
                    materialName: [{required: true, message: '请选择物料', trigger: 'change'}],
                    number: [{required: true, message: '请填写数量', trigger: 'change'}],
                    oneLName: [{required: true, message: '请填产品大类', trigger: 'change'}],
                    reformPrice: [{required: true, message: '请选择改制内容', trigger: 'change'}],
                    reformType: [{required: true, message: '请选择改制类型', trigger: 'blur'}],
                    reformEdition: [{required: true, message: '请选择生产版本', trigger: 'blur'}],
                    stationlist: [{type: 'array', required: true, message: '请至少选择一个物料工位', trigger: 'change'}],



                },
            }
        },
        created() {
            this.f.taskid = this.$route.query.taskid;
            this.f.id =  this.$route.query.ywid;

            //获取物料工位
            this.options = this.$store.getters.dictlist("material_station");
            this.query(this.f.id);
        },
        methods: {

            query(id) {
                reformService.selectById(id).then(rd => {

                    this.f = {...this.f,...rd.obj};

                    //改制明细
                    this.f.specificList = rd.obj.specificList;
                    ///物料工位
                    this.f.stationlist = rd.obj.materialStation? rd.obj.materialStation.split(","): [];

                    //个性化定制标准描述
                    this.f.individualizeList = rd.obj.individualizeReform? rd.obj.individualizeReform.split("##"): [''];
                    //包装标识要求
                    this.f.logoRequestList = rd.obj.logoRequest? rd.obj.logoRequest.split("##"): [''];
                })
            },

            //返回
            backS() {
                this.$router.push({path: "/chanp/reform"});
            },
            viewpress(r){
                this.showhistory = true;
            },



        }
    }
</script>
<style>
    .Yangbiao .h-elformWrap-2 .el-form-item__label {
        width: 45%;
        text-align: right;
    }

    .Yangbiao .el-form-item__content {
        width: 55%;
    }

    .Yangbiao .h-elformWrap-2 {
        width: 25% !important;
        padding-right: 0.5rem
    }
    .Yangbiao .h-elformWrap-5 {
        width: 74% !important;
        padding-right: 0.5rem
    }


    .Yangbiao .h-elformWrap-3 {
        width: 85% !important;
        padding-right: 0.5rem
    }
    .Yangbiao .h-elformWrap-3 .el-form-item__label {
        width: 12%;
        text-align: right;
    }
    .Yangbiao .h-elformWrap-35 {
        width: 77% !important;
        padding-right: 0.5rem
    }
    .Yangbiao .h-elformWrap-35 .el-form-item__label {
        width: 20%;
        text-align: right;
    }
    .Yangbiao .h-elformWrap-4 {
        width: 100%;
        padding-right: 0.5rem
    }

    .Yangbiao .h-elformWrap-4 .el-form-item__label {
        width: 10%;
    }
    .Yangbiao .h-elformWrap-4 .el-form-item__content {
        width: 89%;
    }
    .Yangbiao .w-elformWrap {
        width: 100% !important;
    }
    .w-elformWrap .el-form-item__label {
        width: 14% !important;
    }
    .w-elformWrap .el-form-item__content {
        width: 86% !important;
    }
    .Yangbiao .h-elformWrap-1 {
        width: 100%;
        padding-right: 0.5rem
    }

    .Yangbiao .h-elformWrap-1 .el-form-item__label {
        width: 14%;
    }

    .Yangbiao .h-elformWrap-1 .el-form-item__content {
        width: 86%;
    }

    .Yangbiao.el-form-item__content .el-select {
        width: 100%;
    }

    .ljjtablepaddings6 .h-tableInput .el-input__inner{
        padding: 0.05rem 0.1rem;
    }
    .ljjtablepaddings6 .h-tableInput .el-input__icon{
        line-height: 0.25rem;
    }
    .bbbb {
        padding-top: 5px;
        margin: 0 20px;
    }

    .hang {
        padding: 20px 0;
        margin-bottom: 0;
        background-color: white;
    }
    .ddform_disable_cls .el-form-item__content .el-input__inner[disabled] {
        color: #868686;
    }
</style>
